import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ReactiveFormsModule,      // ★
} from '@angular/forms';
import { CommonModule } from '@angular/common'; // ★
import { DynamicDialogRef, DynamicDialogConfig, DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext'; // ★
import { ButtonModule } from 'primeng/button';       // ★
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AlertService } from 'src/app/services/util/alert.service';
import { AlterarSenhaUsuarioRetaguardaGQL } from 'src/app/generated/graphql';

@Component({
  standalone: true,
  // Adicione todos os módulos aqui 👇
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DynamicDialogModule,
    InputTextModule,
    ButtonModule,
  ],
  template: `
    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="p-fluid"
      autocomplete="off"
    >
      <div class="field">
        <label for="newPassword">Nova senha</label>
        <input
          pInputText
          id="newPassword"
          type="password"
          formControlName="newPassword"
        />
      </div>

      <div class="field">
        <label for="confirmPassword">Confirmar nova senha</label>
        <input
          pInputText
          id="confirmPassword"
          type="password"
          formControlName="confirmPassword"
        />
      </div>
        <small *ngIf="$any(form).errors?.mismatch" class="p-error">
        A confirmação não confere com a nova senha.
        </small>

      <p-footer>
        <button
          pButton
          type="button"
          class="p-button-text"
          label="Cancelar"
          (click)="onCancel()"
        ></button>
        <button
          pButton
          type="submit"
          label="Salvar"
          [disabled]="form.invalid || loading"
          class="p-button-primary"
        ></button>
      </p-footer>
    </form>
  `,
})
export class AlterarSenhaDialogComponent implements OnInit {
  display = true;
  loading = false;
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private auth: AuthService,
    private alert: AlertService,
    private alterarSenha: AlterarSenhaUsuarioRetaguardaGQL
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        newPassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.matchPasswords }
    );
  }

  private matchPasswords = (group: AbstractControl) =>
    group.get('newPassword')!.value === group.get('confirmPassword')!.value
      ? null
      : { mismatch: true };

  onSubmit(): void {
    if (this.form.invalid) return;
    this.loading = true;

    const { newPassword } = this.form.value;
    const usuario = this.auth.getUser();

    this.alterarSenha
      .mutate({
        data: {
          nanoid: usuario!.nanoid,
          novaSenha: newPassword,
        },
      })
      .subscribe({
        next: () => {
          this.loading = false;
          this.alert.showSuccess('Senha alterada com sucesso.');
          this.ref.close(true);
        },
        error: (err) => {
          this.loading = false;
          this.alert.showGQLError(err);
        },
      });
  }

  onCancel(): void {
    this.ref.close(false);
  }
}
